import script from "./CreateEditMixin.vue?vue&type=script&lang=js"
export * from "./CreateEditMixin.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__